/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export const SetResourceAudienceEntryDispositions = {
  ReadOnly: "read_only",
  Destructive: "destructive",
  Idempotent: "idempotent",
  OpenWorld: "open_world",
} as const;
export type SetResourceAudienceEntryDispositions = ClosedEnum<
  typeof SetResourceAudienceEntryDispositions
>;

/**
 * Access to give the principal on this resource. The "blocked_" levels take access away, one scope each and nothing else: "blocked" removes connect, "blocked_view" removes view, "blocked_manage" removes manage. Taking a principal off a resource entirely means writing all three.
 */
export const SetResourceAudienceEntryLevel = {
  Use: "use",
  View: "view",
  Manage: "manage",
  Blocked: "blocked",
  BlockedView: "blocked_view",
  BlockedManage: "blocked_manage",
} as const;
/**
 * Access to give the principal on this resource. The "blocked_" levels take access away, one scope each and nothing else: "blocked" removes connect, "blocked_view" removes view, "blocked_manage" removes manage. Taking a principal off a resource entirely means writing all three.
 */
export type SetResourceAudienceEntryLevel = ClosedEnum<
  typeof SetResourceAudienceEntryLevel
>;

export type SetResourceAudienceEntry = {
  /**
   * Narrow the access to tools carrying these annotations. Omit for the whole resource.
   */
  dispositions?: Array<SetResourceAudienceEntryDispositions> | undefined;
  /**
   * Access to give the principal on this resource. The "blocked_" levels take access away, one scope each and nothing else: "blocked" removes connect, "blocked_view" removes view, "blocked_manage" removes manage. Taking a principal off a resource entirely means writing all three.
   */
  level: SetResourceAudienceEntryLevel;
  /**
   * Principal to grant or block. Use '*' for everyone in the organization.
   */
  principalUrn: string;
  /**
   * Narrow the access to these tool names. Omit for the whole resource.
   */
  tools?: Array<string> | undefined;
};

/** @internal */
export const SetResourceAudienceEntryDispositions$outboundSchema: z.ZodMiniEnum<
  typeof SetResourceAudienceEntryDispositions
> = z.enum(SetResourceAudienceEntryDispositions);

/** @internal */
export const SetResourceAudienceEntryLevel$outboundSchema: z.ZodMiniEnum<
  typeof SetResourceAudienceEntryLevel
> = z.enum(SetResourceAudienceEntryLevel);

/** @internal */
export type SetResourceAudienceEntry$Outbound = {
  dispositions?: Array<string> | undefined;
  level: string;
  principal_urn: string;
  tools?: Array<string> | undefined;
};

/** @internal */
export const SetResourceAudienceEntry$outboundSchema: z.ZodMiniType<
  SetResourceAudienceEntry$Outbound,
  SetResourceAudienceEntry
> = z.pipe(
  z.object({
    dispositions: z.optional(
      z.array(SetResourceAudienceEntryDispositions$outboundSchema),
    ),
    level: SetResourceAudienceEntryLevel$outboundSchema,
    principalUrn: z.string(),
    tools: z.optional(z.array(z.string())),
  }),
  z.transform((v) => {
    return remap$(v, {
      principalUrn: "principal_urn",
    });
  }),
);

export function setResourceAudienceEntryToJSON(
  setResourceAudienceEntry: SetResourceAudienceEntry,
): string {
  return JSON.stringify(
    SetResourceAudienceEntry$outboundSchema.parse(setResourceAudienceEntry),
  );
}
